<template>
  <div id="vhw_contact_form">
    <FormulateForm
      @submit="submitHandler"
    >
      <h2>Kontaktformular</h2>
      <div class="hidden_mail">
        <FormulateInput
                type="email"
                name="email"
        />
      </div>
      <FormulateInput
              name="nachricht"
              type="textarea"
              label="Ihre Nachricht an uns"
      />
      <div class="double-row">
        <FormulateInput
                name="real_mail"
                type="email"
                label="E-Mail*"
                validation="required|email"
                validation-name="E-Mail"
                validation-behavior="blur"
        />
      </div>
      <FormulateInput
              type="checkbox"
              label="Ich akzeptiere die Verarbeitung meiner Daten gemäß den geltenden <a href='/datenschutz'>Datenschutzbestimmungen</a>."
              name="privacy_policy"
              validation="accepted"
              :validation-messages="{
                accepted: 'Sie müssen die Datenschutzbestimmungen akzeptieren.'
              }"
      />
      <FormulateInput
              type="submit"
              :disabled="disabled"
              :label=button_text
              :class=submit_state
      />
      <span>*Pflichtfeld</span>
    </FormulateForm>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'vhw_register_form',
  data () {
    return {
      button_text: "Nachricht absenden",
      disabled: false,
      submit_state: ""
    }
  },
  methods: {
    async submitHandler (data) {
      this.button_text = "Wird gesendet...";
      this.disabled = true;
      axios.post('/wp-content/themes/vhw/_resources/mail/kontakt.php', {
        form_data: data
      })
      .then((response) => {
        if(response.data == 'success') {
          this.button_text = "Erfolgreich abgesendet"
          this.submit_state = "success";
        } else {
          console.error(response);
          this.button_text = "Senden fehlgeschlagen";
          this.submit_state = "error";
        }
      }, (error) => {
        console.error(error);
        this.button_text = "Senden fehlgeschlagen";
        this.submit_state = "error";
      });
    }
  }
}
</script>

<style>
  .hidden_mail {
    display: none;
  }
  .double-row {
    display: flex;
  }
</style>
